import React, { useState, useEffect } from 'react'
import classNames from 'classnames'
import useStateControls from '../../../hooks/useStateControls'
import { MAIN } from '../../../constants/shared/states/names'
import CustomBridge from '../../../controllers/bridge/CustomBridge'
import { useTranslation } from '../../../translations'
import Icon from '../../../components/features/customButton/ui/Icon/Icon'
import { useRequests } from '../../../redux/reducer/requests'
import { abortAllPendingRequests } from '../../../utils/api/api'

export default function AppLoader({ showAbortButton = false }) {
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const { setState } = useStateControls()
  const { t } = useTranslation()
  const {
    authData: { isWeb },
  } = useRequests()

  useEffect(() => {
    if (!showAbortButton) {
      return
    }

    const timer = setTimeout(() => {
      setIsButtonVisible(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  const onClick = () => {
    abortAllPendingRequests()

    setState(MAIN)

    CustomBridge.instance.send({
      name: 'SHOW_NOTIFICATION',
      type: 0,
      data: {
        hasCloseButton: false,
        text: t('loader.notification.error'),
      },
    })
  }

  return (
    <div className={classNames('app-loader', { app: !isWeb })}>
      <button
        type='button'
        onClick={onClick}
        className={classNames('app-loader__button', { visible: isButtonVisible })}
      >
        <Icon icon={'wish/close'} />
      </button>
    </div>
  )
}
